import { useLiveQuery } from 'dexie-react-hooks';
import _ from 'lodash';
import { DexieIndexedDb, PushEventType } from '@cnx-saas/indexed-db';

export function useShipmentEventsCount(): number {
  const shipmentsDeletedPushEvents = useLiveQuery(async () => {
    return DexieIndexedDb.getInstance().getPushEvents({
      type: PushEventType.ShipmentDeleted,
    });
  });
  const deletedShipmentIds = shipmentsDeletedPushEvents?.map(
    (event) => event.payload.id,
  );
  void DexieIndexedDb.getInstance().deletePushEvents(
    shipmentsDeletedPushEvents,
  );

  const zekjuUpdatedPushEvents = useLiveQuery(async () => {
    return DexieIndexedDb.getInstance().getPushEvents({
      type: PushEventType.ZekjuUpdated,
      filter: (event) => !deletedShipmentIds?.includes(event.payload.id),
    });
  });

  const shipmentStatusRejectApprovePushEvents = useLiveQuery(async () => {
    return DexieIndexedDb.getInstance().getPushEvents({
      type: PushEventType.ShipmentStatusRejectApprove,
      filter: (event) => !deletedShipmentIds?.includes(event.payload.id),
    });
  });
  const shipmentUpdatedCount = _.chain(shipmentStatusRejectApprovePushEvents)
    .concat(zekjuUpdatedPushEvents || [])
    .groupBy('payload.id')
    .size()
    .value();

  return shipmentUpdatedCount;
}
